<template src="./Details.html">
</template>

<script>
export default {
    props: {
        itemId: {
            type: Number,
            required: true,
        },
    },
    created() {
        this.$store.dispatch("dispenseRequests/getDetails", this.itemId);
    },
    computed: {
        dispenseRequest() {
            return this.$store.state.dispenseRequests.dispenseRequest;
        }
    },
    data() {
        return {
            expanded: [],

            headers: [
                { text: 'اسم الدواء', value: 'medicineName' },
                { text: 'الكمية', value: 'dispensedQuantity' },
            ],
        };
    },
};
</script>